import { Delete, Pencil, Trash } from 'lucide-react';
import React from 'react'
import { HTTP } from '../../api/http-common';
import Swal from "sweetalert2";

function CouponList({coupon,handleStatusChange,handleEditCoupon,role,fetchCoupons}) {
  const statusChange = (coupon_id,coupon_status) => {
    handleStatusChange(coupon_id,coupon_status);
  };
  const editChange = (coupon) => {
    // console.log(coupon)
    handleEditCoupon(coupon);
  };
  const handleDelete = async (id) => {
    const access_token = localStorage.getItem("access_token");
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    try {
      const access_token = localStorage.getItem('access_token');
      let config = {
      headers: { "Content-Type": "application/json", token: access_token },
      };

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        await HTTP.delete(
            `coupon/delete/${id}`,
            config
        )
          .then(async (response) => {
            if (response.status === 200) {
                Swal.fire({
                    title: response.data.message,
                  //   text: "Please verify your email before login",
                    icon: "success"
                });
                fetchCoupons()
              //   setUsermailToVerify(email);
              //   navigate('/verify');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                  title: 'Error!',
                  text: error.response.data.detail,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
            }
            if (error.response.status === 400) {
                Swal.fire({
                    title: 'Error!',
                    text: 'You are already registered!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                  })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
                Swal.fire({
                    title: 'Error!',
                    text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                  })
            }
          });
        // setIsLoading(false);
        }
      } catch (error) {
      }
  };
  
  return (
    <>
        <tr key={coupon.coupon_code}>
          <td className="admin-table-th-td">{coupon.coupon_code}</td>
          {role === "Admin" && (
            <td className="admin-table-th-td">{coupon.vendor_first_name}</td>
          )}
          <td className="admin-table-th-td">{coupon.coupon_type == 1 ? "Amount" : "Percentage"}</td>
          <td className="admin-table-th-td">
            {coupon.coupon_type == "1" ? `$` : ``} {coupon.coupon_value} {coupon.coupon_type == "2" ? `%` : ``}
          </td>
          <td className="admin-table-th-td">{coupon.minimum_purchase}</td>
          <td className="admin-table-th-td">{coupon.maximum_uses || "Unlimited"}</td>
          <td className="admin-table-th-td">{coupon.usage_count}</td>
          <td className="admin-table-th-td">
            {new Date(coupon.start_date).toLocaleDateString("en-US")}
          </td>
          <td className="admin-table-th-td">
            {new Date(coupon.expiration_date).toLocaleDateString("en-US")}
          </td>
          <td className="admin-table-th-td w-[30%]">{coupon.description}</td>
          <td className="admin-table-th-td">
            <label className="admin-table-toggle-switch">
              <input
                type="checkbox"
                checked={coupon.status === true} // Ensure it's a boolean comparison
                onChange={() => statusChange(coupon.coupon_code, coupon.status)} // Toggle status
                className="admin-table-toggle-input"
              />
              <span
                className={`admin-table-slider ${coupon.status ? "admin-table-slider-checked" : ""}`}
              >
                <span
                  className={`admin-table-slider-before ${coupon.status ? "admin-table-slider-checked-before" : ""}`}
                ></span>
              </span>
            </label>
          </td>
          <td className="admin-table-th-td">
            <div className="flex items-center justify-evenly ">
            <span className='text-[#6c1cff] pe-2'>
              <Pencil className='w-4 h-4 ' onClick={() => editChange(coupon)}/>
            </span>
            {role === "Admin" && (
              <span className='text-[#ff0000] pe-2'>
                <Trash className='w-4 h-4 ' onClick={() => handleDelete(coupon.id)}/>
              </span> 
            )}
            </div>
          </td>
        </tr>
    </>
  )
}

export default CouponList